import _ from 'lodash'
import Vue from 'vue'

import Logger from '@/logger'

import { initialState } from './state'

const MUTATIONS = {

    resetState: 'reset-state-routes',

    storeRoutes: 'store-routes',
}

export { MUTATIONS }

export default {

    /**
     * Resets state.
     *
     * @param {Object} state
     */
    [MUTATIONS.resetState](state) {
        for (const item in initialState)
            Vue.set(state, item, _.cloneDeep(initialState[item]))

        Logger.logObject(state, 'State (Routes) reset', 'Routing')
    },

    /**
     * Updates stored route data in state.
     *
     * @param {Object} state
     * @param {Object} { current, last}
     */
    [MUTATIONS.storeRoutes](state, { current, last }) {
        state.currentRoute = current
        if (last) state.routeStack.push(last)
        Logger.logObject(state, 'Route state updated', 'Routing')
    },
}
